import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PaidIcon from "@mui/icons-material/Paid";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { QrCode2 } from "@mui/icons-material";
import useApi from "_api/index";
import { formatCurrency2Digit } from "utils/helpers/format";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen,
  handleModalRedeemOpen,
  handleModalInterest,
  handleAlertModal,
  handleAlertModalPawn,
  handleModalPrint
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handlePrintQr = async (id) => {
    // Implement QR code printing logic here
    console.log("Print QR code for ID:", id);
    await useApi.product
      .getPrintQrCodeBuyProduct(id)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handlePrintPDF = async (id) => {
    try {
      const response = await useApi.pawn.getPrintPdfPawnOrder(id);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error printing PDF:", error);
    }
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: true },
    { Header: "เลขบัตรประชาชน", accessor: "idcard", showInFilter: true },
    { Header: "ชื่อผู้ขายฝาก", accessor: "customer_name", showInFilter: true },
    {
      Header: "ยอดฝากขาย",
      accessor: "sum_product_total_price",
      showInFilter: true,
      Cell: ({ row }) => (
        <Typography>
          {formatCurrency2Digit(row?.sum_product_total_price || 0)}
        </Typography>
      ),
    },
    {
      Header: "จำนวนทั้งหมด",
      accessor: "sum_product_amount",
      showInFilter: false,
    },
    {
      Header: "วันที่ฝากขาย",
      accessor: "created_at",
      showInFilter: true,
      type: "datepicker",
    },
    {
      Header: "วันที่สิ้นสุด",
      accessor: "order_due_date",
      showInFilter: false,
    },
    { Header: "สถานะ", accessor: "order_status", showInFilter: false },
    {
      Header: "Actions",
      accessor: "actions",
      disableSortBy: false,
      Cell: ({ row }) => {
        // console.log("check due_date row", row);
        const orderStatus = row.order_status; // Use optional chaining

        return (
          <div>
            <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeRowId === row.id}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  setViewProduct(row);
                  handleViewOpen();
                  handleMenuClose();
                }}
              >
                <RemoveRedEyeIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  ดูรายละเอียด
                </span>
              </MenuItem>
              {/* Render "View Details" option only if orderStatus is 1 */}
              {orderStatus === 1 && (
                <>
                  <MenuItem
                    onClick={() => {
                      // Uncomment and add logic for printing if needed
                      // console.log("Print action for product ID:", row.original.id);
                      setProduct(row);
                      // handleModalPrint();
                      handlePrintPDF(row.id);
                      handleMenuClose();
                    }}
                  >
                    <LocalPrintshopIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      พิมพ์ใบขายฝาก
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setProduct(row);
                      handleModalInterest();
                      handleMenuClose();
                    }}
                  >
                    <PaidIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      ต่อดอก
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setProduct(row);
                      handleModalRedeemOpen();
                      handleMenuClose();
                      // console.log("แสดงผลข้อมูล", row);
                    }}
                  >
                    <SwapHorizontalCircleIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      ไถ่ถอน
                    </span>
                  </MenuItem>
                </>
              )}

              {/* Render "Edit" option only if orderStatus is not 1 */}
              {orderStatus === 10 && (
                <>
                  <MenuItem
                    onClick={() => {
                      handleAlertModalPawn(row.id);
                    }}
                  >
                    <ChangeCircleIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      ปรับต้นทุน
                    </span>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleAlertModal(row.id);
                      // setProduct(row.original);
                      // handleModalOpen();
                      // handleMenuClose();
                    }}
                  >
                    <HourglassBottomIcon
                      style={{ marginRight: "8px", color: "#737373" }}
                    />
                    <span style={{ marginLeft: "8px", color: "#737373" }}>
                      หลุดจำนำ
                    </span>
                  </MenuItem>
                </>
              )}
              <MenuItem onClick={() => handlePrintQr(row.id)}>
                <QrCode2 style={{ marginRight: "8px", color: "#737373" }} />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  พิมพ์ QR Code
                </span>
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];
  return columns;
};

export default useColumns;
